<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero 
        span 1
      h1 Empresas

    p.mb-3 La empresa, desde su concepto, se puede abarcar desde distintas perspectivas, que, al leerlas, de alguna forma se complementan. Para este caso en particular, se expondrán algunas de ellas, lo que permitirá construir una definición propia de la misma.

 
    h4.mb-3 Definiciones de empresa
    
    .tarjeta.bg_grad-02.p-4.mb-5(data-aos="zoom-in-up")
      SlyderA
        .row.justify-content-center.align-items-center.p-5
          .col-12.col-md-3.mb-3.mb-md-0
            img.mt-3(src="@/assets/curso/images/tema1/ico_new_1.svg",  alt='', style="width:200px; display:block; margin:auto 0 ;").mb-3
          .col-12.col-md-9.mb-3.mb-md-0
            .bloque-texto-f.color-custom-11.pt-4.px-5.mb-5
              .bloque-texto-f__comillas
                i.fas.fa-quote-left
                i.fas.fa-quote-right
              h5.text-regular.bloque-texto-f__texto.text-center Acción ardua que un individuo o grupo social de emprendedores realiza para llevar a cabo un intento o designio mediante la administración del capital y el trabajo coordinado para producir bienes y servicios con el fin de satisfacer las necesidades de un tercero conocido como cliente, usuario o comunidad.  (Ramírez, 2009).
        .row.justify-content-center.align-items-center.p-5
          .col-12.col-md-3.mb-3.mb-md-0
            img.mt-3(src="@/assets/curso/images/tema1/ico_new_1.svg",  alt='', style="width:200px; display:block; margin:auto 0 ;").mb-3
          .col-12.col-md-9.mb-3.mb-md-0
            .bloque-texto-f.color-custom-11.pt-4.px-5.mb-5
              .bloque-texto-f__comillas
                i.fas.fa-quote-left
                i.fas.fa-quote-right
              h5.text-regular.bloque-texto-f__texto.text-center  “Unidad económica autónoma organizada para combinar un conjunto de factores de producción con vista a la producción de bienes o la prestación de servicios para el mercado” (Matiz, 2009).
        .row.justify-content-center.align-items-center.p-5
          .col-12.col-md-3.mb-3.mb-md-0
            img.mt-3(src="@/assets/curso/images/tema1/ico_new_1.svg",  alt='', style="width:200px; display:block; margin:auto 0 ;").mb-3
          .col-12.col-md-9.mb-3.mb-md-0
            .bloque-texto-f.color-custom-11.pt-4.px-5.mb-5
              .bloque-texto-f__comillas
                i.fas.fa-quote-left
                i.fas.fa-quote-right
              h5.text-regular.bloque-texto-f__texto.text-center  Las empresas son una fuente de ingresos para trabajadores, proveedores, gobierno y empresarios, promueven el desarrollo económico de la sociedad, contribuyen al sostenimiento de servicios públicos, representan un medio para la realización o satisfacción personal, y fomentan la capacitación y el desarrollo de habilidades, así como la inversión y la formación de capital (Münch, 2004).

    .row.aling.my-5   
      .col-lg-12(data-aos="zoom-in-down")
        .cajon.color-custom-1.p-4.mb-4.p-4
          .row.justify-content-around.align-items-center
            .col-lg-12
              .row.justify-content-between.align-items-center
                .col.mb-3.mb-sm-0
                  h4 Conclusión
                  p En conclusión, las empresas son el motor económico de los países, gracias a que a través suyo se genera riqueza y empleo, dinamizando el desarrollo de las naciones; razón por la cual  son reconocidas como la unidad productiva de la economía. Fueron creadas para ofertar bienes y servicios, y a través de ellas se formalizaron las transacciones u operaciones comerciales; de tal manera que el trueque dio paso a generar la necesidad de retribución económica por los productos y servicios vendidos, lo cual genera a su vez un beneficio tanto para el productor/comercializador como para el cliente o beneficiario del servicio o producto.


    .row.align-items-center.justify-content-center.mb-3
      .col-lg-6(data-aos="fade-right") 

          p.mb-3 La empresa, entonces, también se define como un conjunto de factores económicos que, coordinados o bien direccionados por el empresario, cumplen la función de producir bienes y lograr un objetivo que constantemente es maximizar el valor de su empresa, es decir, a través de su desempeño lograr generar riqueza o fortalecer su capital.

          p.mb-5 Las empresas también cumplen funciones no solo económicas sino sociales, pues a través de sus decisiones, de la responsabilidad social empresarial, de la interacción con el colaborador, la asignación y desarrollo de funciones, sumado a las capacitaciones y entrenamientos que brinda, con el fin de lograr la productividad en todas las áreas que la integran, genera a su vez un desarrollo profesional en cada integrante de la organización como motivación para mejorar su cualificación y para realizarse en el área profesional.

   
      .col-lg-4(data-aos="fade-left") 
        img.mt-3(src='@/assets/curso/images/tema1/img_1.png')

  .container.bg-white.px-md-5.px-3.py-2.container-top.fondo-1.mb-0.mg-top-1
    .row.align-items-star.justify-content-center.mb-5
      .col-lg-6(data-aos="fade-left") 
        img.mt-3(src='@/assets/curso/images/tema1/img_2.png').mb-3

      .col-lg-6(data-aos="fade-right") 

          p.mb-3 Al estar compuesta por áreas funcionales, cada una de ellas aporta al desarrollo integral de la empresa, lo que, a su vez, redunda en un beneficio regional e incluso nacional si las magnitudes de sus innovaciones o transformaciones permiten alcanzar grandes retos o resolver grandes problemas, despertando niveles elevados de interés, como la inversión extranjera, generando de esta manera el ingreso de divisas al país, lo cual beneficia a todo el territorio nacional.

          p.mb-5 Ahora bien, las características de la empresa son los rasgos que la identifican como ente productivo y económico que ofrece bienes y servicios. Esta inicia sus actividades, como se ha mencionado, con gran expectativa de satisfacer las necesidades de los clientes y poder llegar a fidelizarlos, generando así ingresos que le permitan ampliar su capacidad productiva, lanzar nuevas líneas de productos, crecer y consolidarse en el sector al que pertenezca. La organización debe estar cargada de dinamismo para adaptarse a los cambios que el entorno le presente y coordinar sus recursos para el logro de los objetivos. Por tanto, las siguientes pueden identificarse como sus características.
  .container.bg-white.p-md-5.p-4.container-bottom.mt-0.mg-top-1.mb-5 
    .row.align-items-center.justify-content-center.mb-5
      .col-lg-8
        .titulo-sexto.color-acento-contenido.mb-5(data-aos="zoom-in-right")
          h5 Figura 2
          span  Características de la empresa

    .row.align-items-center.justify-content-center.mb-5
      .col-lg-8(data-aos="fade-left") 
          img.mt-3(src='@/assets/curso/images/tema1/fig_2.svg')


    Separador

    #t_1_1.titulo-segundo
      .h2 1.1 Clasificación 


    p.mb-5 La clasificación o tipologías de las empresas tiene su origen en determinados criterios. A continuación, se desarrolla cada uno de ellos.

    .row.mb-3.ps-2(data-aos="zoom-in-down")
      .col-lg-4.bg-color-1.px-3.py-1
        .h4.mb-0.text-white Tamaño


    p.mb-3 La magnitud de la empresa estaba dada por el número de colaboradores en actividad, pero, a partir del mes de junio, el Gobierno Nacional, mediante Decreto 957 de 2019, definió el criterio único de clasificación del tamaño de las empresas de acuerdo con sus ingresos por actividades ordinarias, el cual entró en vigencia en diciembre del mismo año, así:

  .container.bg-white.px-md-5.px-3.py-2.container-top.fondo-1.mb-0.mg-top-1
    .row.align-items-center.justify-content-center
      .col-lg-10
        .titulo-sexto.color-acento-contenido.mb-3(data-aos="zoom-in-right")
          h5 Tabla 1
          span   Clasificación del tamaño empresarial según el criterio único de ingresos por actividades ordinarias
        .tabla-a.color-acento-contenido.mb-5 
          table
            caption Cifras de ingresos por actividades ordinarias anuales en millones de pesos colombianos de 2019 
            thead
              tr      
                th.th.text-table-1 Tamaño
                th.th.text-table-1 Manufactura
                th.th.text-table-1 Servicios
                th.th.text-table-1 Comercio
            tbody
              tr
                th.th-1.text-table Micro
                td.th-1.text-table  Hasta 811
                td.th-1.text-table  Hasta 1.131   
                td.th-1.text-table  Hasta 1.535  
              tr 
                th.th-2.text-table Pequeña
                td.th-2.text-table Desde 811 hasta 7.027
                td.th-2.text-table Desde 1.131 hasta 4.523
                td.th-2.text-table Desde 1.535 hasta 14.781
              tr 
                th.th-1.text-table Mediana  
                td.th-1.text-table  Desde 7.027 hasta 59.527
                td.th-1.text-table  Desde 4.523 hasta 16.558
                td.th-1.text-table  Desde 14.781 hasta 74.066

  .container.bg-white.p-md-5.p-4.container-bottom.mt-0.mb-5 

      .row.mb-5.ps-2(data-aos="zoom-in-down")
        .col-lg-4.bg-color-2.px-3.py-1
          .h4.mb-0.text-white Actividad y sector al que pertenecen
    

      p.mb-3 Las empresas también pueden ser clasificadas de acuerdo a su actividad y sector al que pertenecen, tal como se aprecia en el siguiente recurso:

      TabsC.color-acento-contenido.mb-5(data-aos="zoom-in-down")
        .py-4.py-md-4(titulo="Primario")
          .row.justify-content-center.align-items-center.p-4
            .col-12.col-md-4.mb-3.mb-md-0
              img.mt-3(src="@/assets/curso/images/tema1/img_4.png").m-auto
            .col-12.col-md-6.mb-3.mb-md-0
              h4 Primario
              p.mb-0 Es el dedicado a la explotación de la tierra o a la explotación de los recursos naturales, ya sea renovables o no renovables. Son actividades extractivas o mineras, agropecuarias como producción de bovinos, caprinos, ovinos y porcinos, y agrícolas, entre otras.

        .py-3.py-md-4(titulo="Secundario")
          .row.justify-content-center.align-items-center.p-4
            .col-12.col-md-4.mb-3.mb-md-0
              img.mt-3(src="@/assets/curso/images/tema1/img_3.png").m-auto
            .col-12.col-md-6.mb-3.mb-md-0
              h4 Secundario
              p.mb-0 Es la actividad de las empresas ubicadas en la producción de bienes mediante la transformación o extracción de materias primas. En él, se encuentran empresas manufactureras que transforman la materia prima en productos finales, y las organizaciones dedicadas a producir bienes de producción para abastecer la industria manufacturera o industrial.
      
        .py-3.py-md-4(titulo="Terciario")
          .row.justify-content-center.align-items-center.p-4
            .col-12.col-md-4.mb-3.mb-md-0
              img.mt-3(src="@/assets/curso/images/tema1/img_5.png").m-auto
            .col-12.col-md-6.mb-3.mb-md-0
              h4 Terciario
              p.mb-0 Son las empresas que ofrecen servicios intangibles a disposición de la comunidad en general. Entre estos, se encuentran la educación, el turismo, salud, finanzas, <i>outsourcing</i> y transporte, entre otros. Los servicios ofertados en este sector tienen la característica principal de ser conocidos y evaluados solo cuando se disfrutan o vivencian.


        .py-3.py-md-4(titulo="Cuaternario")
          .row.justify-content-center.align-items-center.p-4
              .col-12.col-md-4.mb-3.mb-md-0
                img.mt-3(src="@/assets/curso/images/tema1/img_6.png").m-auto
              .col-12.col-md-6.mb-3.mb-md-0
                h4 Cuaternario
                p.mb-0 Son las actividades intelectuales asociadas con el gobierno, la cultura, las bibliotecas, la investigación científica, la educación y la tecnología de la información.
                
  .container.bg-white.px-md-5.px-3.py-2.container-top.fondo-1.mb-0.mg-top-1
      .row.mb-5.ps-2(data-aos="zoom-in-down")
        .col-lg-4.bg-color-3.px-3.py-1
          .h4.mb-0.text-white Origen de capital


      .row.align-items-center.justify-content-center.mb-3
        .col-lg-7(data-aos="fade-right") 

            p.mb-3 Según el origen del capital correspondiente a la inversión para dar inicio a la operación de la empresa, puede ser privado si el capital, representado en dinero o bienes, es invertido en la organización y viene de socios; también, puede ser público si el capital proviene de las arcas del Estado; y mixtas  si el capital aportado proviene de socios, que pueden ser personas naturales o jurídicas, y de entidades del Estado, simultáneamente. También existen las empresas donde el capital está en manos de los trabajadores, denominadas empresas de autogestión.

            p.mb-0 “Las sociedades de economía mixta se sujetan a las reglas del derecho privado y a la jurisdicción ordinaria, salvo disposición legal en contrario” (Art. 461 del Código de Comercio, 2020).

    
        .col-lg-5(data-aos="fade-left") 
          img.mt-3(src='@/assets/curso/images/tema1/img_7.png')

  .container.bg-white.p-md-5.p-4.container-bottom.mt-0.mb-5 
    .row.mb-5.ps-2(data-aos="zoom-in-down")
        .col-lg-4.bg-color-4.px-3.py-1
          .h4.mb-0.text-white Según su forma jurídica


    p.mb-3 Forma jurídica se refiere a la constitución legal que se realiza de la empresa y en qué tipo de sociedad se convierte la organización al ser legalmente constituida, asumiendo unas características que la identifican y unas responsabilidades legales y fiscales ante el Estado. 


    .row.justify-content-evenly.align-items-center
      .col-12.col-lg-6.mb-4-md-5(data-aos="fade-left")
        LineaTiempoD.color-secundario.especial
          .row(titulo='¿Qué son las sociedades?' numero='1')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3  La sociedad es la reunión de personas naturales o jurídicas que unen sus esfuerzos bajo una figura legal constituida mediante escritura pública y cumpliendo con todos los requisitos de ley para su creación, bajo la cual se asigna un nombre que debe quedar instaurado en todos los estamentos relacionados con la constitución de la empresa y que debe declarar con claridad el tipo de responsabilidad a que corresponde. 
                p.mb-3 Esta figura se denomina persona jurídica, la cual tiene derechos y responsabilidades. Asimismo, puede ser representada judicial y extrajudicialmente.
 
                p.mb-0 En Colombia, se pueden constituir diferentes tipos de sociedades, tales como: sociedad limitada, empresa unipersonal, sociedad anónima, sociedad colectiva, sociedad por acciones simplificada S.A.S., sociedad en comandita, entre otras. Cada una de ellas tiene unas características y responsabilidades diferentes.

          .row(titulo='Sociedad limitada' numero='2')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0

                p.mb-3  Este tipo de sociedad se caracteriza porque la responsabilidad de sus socios está relacionada con el monto o valor de sus aportes, lo cual define su nivel de responsabilidad. Es decir, cada socio es responsable de las decisiones tomadas en la empresa y sus consecuencias respondiendo por ello hasta el monto de sus aportes.
 
          
          .row(titulo='Sociedad anónima' numero='3')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3 Esta sociedad se forma por la unión de mínimo cinco socios, sin límite o máximo impuesto. Se constituye cuando los aportes de capital se realizan mediante la compra de acciones y su responsabilidad corresponde al monto o valor de sus aportes.
          .row(titulo='Empresa asociativa de trabajo' numero='4')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p Este tipo de empresa es particular porque está integrada por socios quienes aportan su capacidad laboral por tiempo indefinido y su vinculación con este tipo de organización no es laboral sino comercial. Su objeto es producir, comerciar y distribuir bienes básicos de consumo familiar o la prestación de servicios individuales o conjuntos de sus miembros. La personería jurídica de este tipo de empresas asociativas será reconocida desde su inscripción en la Cámara de Comercio (CCC, 2020). 
          
          .row(titulo='Sociedad colectiva' numero='5')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
  
                p.mb-0  En este tipo de sociedad, todos los socios, en nombre colectivo, responderán solidaria e ilimitadamente por las operaciones sociales.
      .col-lg-6(data-aos="fade-right").mb-5
        img(src='@/assets/curso/images/tema1/img_10.png')
    .row.justify-content-evenly.align-items-center
      .col-lg-6(data-aos="fade-right").mt-3
        img(src='@/assets/curso/images/tema1/img_8.png').mb-3
      .col-12.col-lg-6.mb-4-md-5(data-aos="fade-left")
        LineaTiempoD.color-secundario.especial
          .row(titulo='Sociedad por acciones simplificada S.A.S.' numero='6')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3  Este tipo de empresa podrá constituirse por una o más personas naturales o jurídicas, quienes tendrán responsabilidad en este tipo de sociedad hasta el monto de sus aportes. Fue creada por la Ley 1258 de 2008, tiene naturaleza comercial indistinta de las actividades que incluyen su objeto social, este último puede ser indeterminado para realizar actividades legales y fue creada como estrategia para promover el emprendimiento. 

          .row(titulo=' Sociedad en comandita simple S. en C.' numero='7')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3  Se constituye siempre entre uno o más socios que se comprometen solidaria e ilimitadamente por las operaciones realizadas, denominados <b>socios gestores</b>, y otro o varios socios que limitan la responsabilidad a sus respectivos aportes reconocidos como <b>socios comanditarios.</b>
                p.mb-0 La razón social de la sociedad comanditaria simple se formará con el nombre completo o sólo el apellido de uno o más socios colectivos y se agregará la expresión “y compañía” o la abreviatura “& Cía”, seguida de la indicación abreviada S. en C.


          .row(titulo='Sociedad en comandita por acciones' numero='8')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3  Esta sociedad  se crea entre uno o más socios que comprometen solidaria e ilimitadamente su responsabilidad por las operaciones que realicen los reconocidos como socios gestores, y otro o varios socios que limitan la responsabilidad al monto de sus aportes, denominados socios comanditarios. 

                p.mb-0 La razón social de la sociedad en comandita por acciones se formará con el nombre completo o solo el apellido de uno o más socios colectivos, y se agregará la expresión “y compañía” o la abreviatura “& Cía”, seguida de las palabras “sociedad comanditaria por acciones” o su abreviatura “SCA”, que significa: esta es una sociedad  colectiva. (CCC, 2020).

      
    .row.aling.my-2   
      .col-lg-10(data-aos="zoom-in-down")
        .cajon.color-custom-1.p-2.mb-4
          .row.justify-content-around.align-items-center
            .col-lg-12
              .row.justify-content-between.align-items-center.p-3
                .col.mb-3.mb-sm-0
                  h4 Empresa de una persona o Empresa unipersonal
                  p.mb-0 Es posible constituir una empresa con un solo socio, que conforme una persona jurídica distinta a ese único socio, pero técnicamente no es una sociedad unipersonal. La sociedad unipersonal no existe como consecuencia de la creación de las S.A.S., lo que existe es la empresa unipersonal, creada por la Ley 222 de 1995, que no tiene la característica de sociedad (Gerencia.com, 2022).

    .row.aling.my-5   
      .col-lg-8
        p.mb-3 Para ampliar la información alrededor de los tipos de sociedades en Colombia, se sugiere revisar los siguientes recursos.


    .row.align-items-center.aling.my-3
      .col-lg-8(data-aos="zoom-in-down")
        .tarjeta.color-custom-4.p-4.mb-5
          .row.justify-content-center.align-items-center
            .col
              .row.justify-content-between.align-items-center
                .col-lg-2
                  img.mx-1(src="@/assets/curso/images/tema1/ico_2.svg",  alt='', style="width:100px; display:block; margin:auto 0 ;").mb-3
                .col.mb-3.mb-sm-0
                  h5 Tipos de sociedades en Colombia
                  p.mb-1.text Amplía el conocimiento sobre los tipos de sociedades en Colombia.
                .col-md-auto
                  a.boton.color-acento-botones(href="https://youtu.be/aOUKzNrTLPE" target="_blank")
                    span Ver video
                    .row
                      .col-auto
                        img.mx-1(src="@/assets/curso/images/tema1/ico_video.svg",  alt='', style="width:20px; display:block; margin:auto 0 ;")


    .row.align-items-center.aling.my-3
      .col-lg-8(data-aos="zoom-in-down")
        .tarjeta.color-custom-5.p-4.mb-5
          .row.justify-content-center.align-items-center
            .col
              .row.justify-content-between.align-items-center
                .col-lg-2
                  img.mx-1(src="@/assets/curso/images/tema1/ico_3.svg",  alt='', style="width:100px; display:block; margin:auto 0 ;").mb-3
                .col.mb-3.mb-sm-0
                  h5 Consolidado de sociedades en Colombia
                  p.mb-1.text El siguiente cuadro comparativo permite analizar cada una de las sociedades de acuerdo con sus características. Recurso que también puede ser consultado en el material de apoyo.
                .col-md-auto
                  a.boton.color-custom-6.texto-blanco(:href="obtenerLink('downloads/ConsolidadodesociedadesenColombia.pdf')" target="_blank")
                    span Descargar
                    .row
                      .col-auto
                        img.mx-1(src="@/assets/curso/images/tema1/Ico_download.svg",  alt='', style="width:20px; display:block; margin:auto 0 ;")
    Separador

    #t_1_2.titulo-segundo
      .h2 1.2 Áreas funcionales

    p.mb-5 Cuando se mencionan áreas funcionales de la empresa, se hace referencia a todas las unidades, áreas o departamentos que son necesarios para el funcionamiento u operación de la organización, entre las cuales se dividen las responsabilidades, bien sea por funciones o especialidad. A continuación, se exponen las principales.

    TabsB.color-primario.mb-5
      .py-4.py-md-5.bg-rosa.p-4(titulo="Dirección" :icono="require('@/assets/curso/images/tema1/icon.svg')")
        .row
          .col-md-8.mb-4.mb-md-0
            h4 Dirección
            p.mb-3  El área de dirección en una organización es conocida como alta gerencia, gerencia, dirección, administración, entre otros. En ella, se define el rumbo de la empresa, es decir, se establece el qué quiere lograr a través de su operación  u objetivos organizacionales, se toman decisiones importantes para el rumbo de la misma y se dirigen las operaciones que debe desarrollar para alcanzar lo planteado. 

            p.mb-0 Esta área funcional dentro de la organización también se reconoce como la primera etapa del proceso administrativo, lo que configura el liderazgo y diseño de la empresa, por lo cual tiene una estrecha relación con la última etapa del proceso administrativo, denominada control, que en síntesis es donde se evalúa el desempeño organizacional de la medición de resultados y se toman nuevas decisiones para iniciar de nuevo un enfoque, camino o estrategia.
        
          .col-md-4
            figure
              img(src='@/assets/curso/images/tema1/img_tab_1.png', alt='Texto que describa la imagen')
      
      .py-4.py-md-5.bg-rosa.p-4(titulo="Recursos humanos" :icono="require('@/assets/curso/images/tema1/icon_2.svg')")
        .row
          .col-md-8.mb-4.mb-md-0
            h4 Recursos humanos
            p.mb-3 Esta área cobra gran importancia por la magnitud de su responsabilidad frente al logro de objetivos. Se dedica a  buscar, reclutar, seleccionar, contratar, entrenar y formar el talento humano de la organización. También, define las estrategias para que la productividad de la empresa sea al máximo, y esto va ligado a los planes de beneficios orientados al personal o equipo de trabajo de toda la organización.
            p.mb-0 Adicionalmente, es responsable de todo lo relacionado con las actividades de tipo administrativo, la comunicación interna, la capacitación y los aspectos legales del personal a cargo, entre otros.
          .col-md-4
            figure
              img(src='@/assets/curso/images/tema1/img_tab_2.png', alt='Texto que describa la imagen')
  
      .py-4.py-md-5.bg-rosa.p-4(titulo="Producción" :icono="require('@/assets/curso/images/tema1/icon_3.svg')")
        .row
          .col-md-8.mb-4.mb-md-0
            h4 Producción
            p.mb-0 Esta área está ligada directamente a la razón de ser de la empresa o misión. En ella se elaboran o producen los bienes y servicios que la empresa comercializa, esto ocurre a través de la transformación de la materia prima en productos terminados. Además, es responsable de asegurar el óptimo aprovechamiento de los recursos en el proceso productivo, se encarga de controlar la calidad de los productos elaborados con el fin de cumplir con las expectativas del cliente y de adquirir los insumos en las condiciones y calidad requeridas, así como los mejores  proveedores.
        
          .col-md-4
            figure
              img(src='@/assets/curso/images/tema1/img_tab_3.png', alt='Texto que describa la imagen')


      .py-4.py-md-5.bg-rosa.p-4(titulo="Finanzas o contabilidad" :icono="require('@/assets/curso/images/tema1/icon_4.svg')")
        .row
          .col-md-8.mb-4.mb-md-0
            h4 Finanzas o contabilidad
            p.mb-0 En el área de finanzas, se registran todas las operaciones que realiza la empresa. Tiene a su cargo todos los movimientos de dinero que se producen dentro y fuera de la misma. En otras palabras, esta área es responsable de los recursos monetarios y financieros que posee la empresa. Aquí se maximizan los recursos obtenidos a través de las inversiones y se realizan los pagos por los diferentes conceptos requeridos para garantizar su operación, como arrendamientos, publicidad, colaboradores y proveedores. En esta área, se elaboran los informes financieros y se cumple con las obligaciones fiscales.
        
          .col-md-4
            figure
              img(src='@/assets/curso/images/tema1/img_tab_4.png', alt='Texto que describa la imagen')

        
      
      .py-4.py-md-5.bg-rosa.p-4(titulo="<i>Marketing</i> y ventas" :icono="require('@/assets/curso/images/tema1/icon_5.svg')")
        .row
          .col-md-8.mb-4.mb-md-0
            h4 <i>Marketing</i> y ventas
            p.mb-3  Esta área direcciona sus esfuerzos en la planificación y diseño de nuevos productos, estableciendo el ciclo de vida que tendrán. Define las estrategias de <i>Marketing</i> que se aplicarán de acuerdo con el mercado o segmento, para una efectiva captación de clientes, mediante una comunicación estratégica. Sus esfuerzos se orientan al exterior de la empresa.

            p.mb-0 Se encarga de planificar la mezcla de <i>marketing</i> en cuanto a producto, precio, comunicación y distribución, con base en los distintos bienes y servicios que ofrece al mercado.
        
          .col-md-4
            figure
              img(src='@/assets/curso/images/tema1/img_tab_5.png', alt='Texto que describa la imagen')


    h5 Otras áreas

    .row.justify-content-evenly.align-items-star.p-2
      .col-lg-7(data-aos="fade-right")
        AcordionA(tipo="a" clase-tarjeta="tarjeta tarjeta--gris")(data-aos="zoom-in-down")
          .row.justify-content-center.align-items-center(titulo="Innovación")
            .col-md-9.mb-4.mb-md-0
              p.mb-0  En esta área, se originan nuevas ideas de productos, así como la mejora en las prácticas y procesos tanto de producción como de comercialización.
            .col-6.col-lg-2.mb-4.mb-lg-0
              img(src='@/assets/curso/images/tema1/ico_new_2.svg' alt='', style="width:120px; display:block; margin:auto 0;")
          .row.justify-content-center.align-items-center(titulo="Tecnología")
            .col-md-9.mb-4.mb-md-0
              p.mb-3  En este departamento, se desarrolla el <i>hardware</i> y el <i>software</i> que brinda el soporte técnico y que se usará para el manejo de datos e información. Además de aportar para que los procesos de producción y comercialización se vuelvan más eficientes.
            .col-6.col-lg-2.mb-4.mb-lg-0
              img(src='@/assets/curso/images/tema1/ico_new_3.svg'  alt='', style="width:120px; display:block; margin:auto 0;")
          .row.justify-content-center.align-items-center(titulo="Servicio al cliente")
            .col-md-9.mb-4.mb-md-0
              p.mb-3  Busca atender y servir de mejor forma a los clientes de la empresa, dando respuesta rápida a los requerimientos de los clientes, como reclamos, quejas e inquietudes, con el fin de mantener su fidelidad.
            .col-6.col-lg-2.mb-4.mb-lg-0
              img(src='@/assets/curso/images/tema1/ico_new_4.svg'  alt='', style="width:120px; display:block; margin:auto 0;")
      .col-lg-5(data-aos="fade-right")
        img(src='@/assets/curso/images/tema1/img_11.png' alt='', style="width:500px; display:block; margin:auto 0;")

    Separador

    #t_1_3.titulo-segundo
      .h2 1.3 Diagnóstico organizacional

    p.mb-5 Para definir el diagnóstico organizacional como herramienta estratégica para la organización, es necesario conocer el concepto de diagnóstico presentado en el siguiente video.

    figure.mb-5
      .video
        <iframe width="560" height="315" src="https://www.youtube.com/embed/Q8UBmSaGk48" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    p.mb-3 Algunas causas que dan origen al diagnóstico organizacional, de acuerdo con Celaya (2010), son:

  .container.bg-white.px-md-5.px-3.py-2.container-top.fondo-1.mb-0.mg-top-1
    .titulo-sexto.color-acento-contenido.mb-3(data-aos="zoom-in-right")
      h5 Figura 4
      span  Causas del diagnóstico organizacional
    .row.align-items-center.justify-content-center.mb-5
      .col-lg-12(data-aos="fade-left") 
        img.my-3(src='@/assets/curso/images/tema1/fig_4_1.png')

    .row.justify-content-center.align-items-center
      .col-lg-12(data-aos="zoom-in-down")
         .cajon.color-custom-1.p-3.mb-4
          .row.justify-content-center.align-items-center
            .col-6.col-lg-2.mb-4.mb-lg-0
              img.mx-5(src="@/assets/curso/images/tema1/ico_fig.svg",  alt='', style="width:120px; display:block; margin:auto 0 ;")
            .col-lg-10
              p.mb-0 En cualquiera de estas causas, el diagnóstico organizacional se hace necesario, debido a que, cuando una organización nace, se estructura con la medida justa de procesos y personal para atender la demanda de ese momento, pero cuando ella empieza su crecimiento, los procesos, el personal e incluso la infraestructura pueden ser insuficientes. 

      p.mb-3 De igual forma, sucede cuando una organización se ha deteriorado, quiere decir que no ha realizado renovación en ningún aspecto durante su trayectoria en el mercado, por lo cual es posible que tienda a desaparecer, pues puede ser que hasta su producto y estrategias sean obsoletas. 

      p.mb-0 También se da cuando la organización ha asumido cambios importantes, requiere de la aplicación de esta herramienta con el fin de identificar el impacto que estas variaciones han tenido en las diferentes áreas de la empresa o prevenir las modificaciones que pudieran ser generadas por la evolución que se implementará.
  .container.bg-white.p-md-5.p-4.container-bottom.mt-0.mb-0
    .row.align-items-center.justify-content-center.mb-3
      .col-lg-5(data-aos="fade-left") 
        img.mt-3(src='@/assets/curso/images/tema1/img.png').mb-3
      .col-lg-5(data-aos="fade-right") 

          p.mb-3  De otra parte, cuando la organización está inmersa en un entorno bastante complejo, es necesario que mantenga cierta cercanía con ese grado de complejidad, de manera que, al incrementar esa misma complejidad en el entorno, es decir, cambios de gobierno o cambio de política, entre otros, estará obligada a aumentar su complejidad interna, en otras palabras, a desarrollar mayor fortaleza en los procesos, o contracción de la producción, si es el caso; en fin, diferentes cambios drásticos que deba afrontar, para lo cual requiere estar preparada y lo cual genera la habilidad de adaptación constante en congruencia con los cambios que se presentan en el contexto.

          p.mb-0 De ahí, la importancia de trabajar de la mano con su talento humano, pues, al construir un sentido de pertenencia sólido, se crea un clima organizacional sin fronteras, permitiendo el avance constante hacia nuevas tendencias y nuevos retos que, al asumirlos, generan crecimiento para ambas partes.
                  
    .row.align-items-center.aling.my-3
      .col-lg-12(data-aos="zoom-in-down")
         .cajon.color-custom-12.p-4.mb-4.p-4
          .row.justify-content-center.align-items-center
            .col
              .row.justify-content-between.align-items-center
                .col-lg-12
                  p.mb-1.text Para realizar el diagnóstico organizacional se requiere de información ya disponible o de nueva información suministrada mediante los antecedentes, por ello, es  imprescindible definir un parámetro que facilite hacer relevantes algunos elementos y descartar otros para acentuar los de mayor trascendencia y definir con claridad la coyuntura actual de la organización, como son las dificultades en la actualidad.

    p.mb-3 El diagnóstico organizacional orienta la organización hacia el logro de la eficiencia empresarial, para lo cual se ha identificado la necesidad de incluir tres clases de herramientas:

    .row.justify-content-around.align-items-center.mb-5(data-aos="zoom-in-right")
      .col-md-6.col-lg.mb-5.mb-lg-0
        .tarjeta-avatar
          img(src='@/assets/curso/images/tema1/ico_4.svg',  alt='', style="width:130px; display:block; margin:auto 0 ;")
          .tarjeta.color-custom-7
            .p-4
              h4.text-center.mb-4 Herramientas conceptuales
              p.text-center.mb-4 Es indispensable consolidar conceptos y fundamentos que promuevan la comprensión acerca del funcionamiento de las organizaciones y su comportamiento, lo que hace la diferencia entre empresas eficientes e ineficientes.

      .col-md-6.col-lg.mb-5.mb-lg-0
        .tarjeta-avatar
          img(src='@/assets/curso/images/tema1/ico_5.svg',  alt='', style="width:130px; display:block; margin:auto 0 ;")
          .tarjeta.color-custom-8
            .p-4
              h4.text-center.mb-5 Técnicas y procesos de medición
              p.text-center.mb-4 Es necesario definir una herramienta que recoja información acerca de la operación empresarial eficiente, con el fin de validar su efectividad e iniciar acciones en su desempeño, actividades y el impacto sobre sus integrantes.

      .col-md-6.col-lg.mb-5.mb-lg-0
        .tarjeta-avatar
          img(src='@/assets/curso/images/tema1/ico_6.svg',  alt='', style="width:130px; display:block; margin:auto 0 ;")
          .tarjeta.color-custom-13
            .p-4            
              h4.text-center Tecnologías de cambio
              p.text-center.mb-0 Debido al conocimiento acerca de la operatividad de la empresa y la información acerca de su funcionamiento, mediante herramientas para consolidar información conveniente, es posible implementar técnicas y procedimientos específicos para modificar pautas de comportamiento aportando a la eficiencia.


    .row.align-items-center.justify-content-center.mb-3
      .col-lg-7(data-aos="fade-right") 

          p.mb-3 Para realizar una intervención en la empresa a través del diagnóstico organizacional, se hace necesario que el consultor realice una entrevista con la persona interesada o gerente de la organización, quien expondrá su interés de contar con esta implementación y definirá la situación, para dimensionar el problema y conocer sus alcances, así como cuáles son sus habilidades, fortalezas, dificultades, debilidades y áreas de oportunidad, dejando claro que, al someter a una empresa a un proceso de diagnóstico se direcciona a que los actores que hacen parte de esta se dispongan a nuevos retos que deben ser desarrollados por ellos como parte de la organización y nunca por alguien externo. 

          p.mb-0 Para implementar el diagnóstico organizacional, se hace necesario construir un proyecto que lleve su nombre, requiriendo, en primera instancia, desarrollar la primera entrevista y develar las pretensiones de los intervinientes, así como sus perspectivas y los diferentes inconvenientes que deben ser identificados en la inversión a realizar. El plan de trabajo deberá llevar los siguientes elementos y un proceso determinado, de acuerdo con Bravo (2019).
  
      .col-lg-5(data-aos="fade-left") 
        img.mt-3(src='@/assets/curso/images/tema1/img_9.png')

    .titulo-sexto.color-acento-contenido.mb-5(data-aos="zoom-in-right")
      h5 Figura 5
      span   Proceso y elementos de un diagnóstico
    .row.align-items-center.justify-content-center.mb-5
      .col-lg-12
        img.mt-3(src='@/assets/curso/images/tema1/fig_5.png')

    .row.align-items-center.justify-content-center
      .col-lg-10
        .jumbotron-3.p-4
          p.text-center.mb-0 Es necesario construir el plan de trabajo, con el paso a paso del proceso a realizar, para evitar inconvenientes en la búsqueda de información; se debe realizar de  manera ordenada, que, a su vez, permita evaluar la confiabilidad y validez tanto del proceso mismo como de la información recolectada.
    Separador

    #t_1_4.titulo-segundo
      .h2 1.4 Matrices diagnósticas 

    p.mb-3 Las matrices diagnósticas han sido diseñadas con el fin de condensar diferentes factores claves de éxito de una organización, para medirlos o evaluarlos desde la realidad de su desempeño y operación empresarial. Ellas son instrumentos poderosos para la gestión empresarial, que permiten recoger información sobre diferentes aspectos de la empresa, para que luego, a través de la aplicación de otras estrategias o simplemente del análisis del conjunto de información, se pueda construir una conclusión. A continuación, se desarrollan las más relevantes.

    TabsC.color-acento-contenido.mb-5(data-aos="zoom-in-down")
      .py-4.py-md-4.tabs-c__content-item-1.tab-c.mg-top-2(titulo="Matriz FODA")
        .row.justify-content-center.align-items-center.p-4
          .col-12.col-md-6.mb-3.mb-md-0
              h4 Matriz FODA
              p.mb-3 FODA es la sigla de fortalezas, oportunidades, debilidades y amenazas. Es un  instrumento complementario al perfil de capacidades internas (PCI), al perfil de oportunidades y amenazas en el medio (POAM) y al análisis de competitividad (perfil competitivo PC). El análisis FODA permite dilucidar la capacidad de la organización para desempeñarse en el ámbito en el que está vinculada.

              p.mb-0 El estudio FODA nace como respuesta a la necesidad de encontrar estrategias que compaginen con las tendencias del ambiente, a partir de las potencialidades, riesgos potenciales, así como de las capacidades internas que posee la empresa. Este estudio facilita la formulación de estrategias para redituar sus fortalezas, prepararse acerca de los efectos de sus debilidades, recurrir a sus potencialidades y prepararse para el impacto de la aparición de amenazas. Cuanto más competitiva sea la empresa en el medio al que pertenece, más oportunidades tendrá de ser exitosa, este conocimiento de competencia conlleva consecuencias maravillosas para la implementación de una estrategia efectiva.  (Pedraza, 2015).
          .col-12.col-md-4.mb-3.mb-md-0
            .row.justify-content-end.align-items-center
              .col-md-12
                figure
                  img(src="@/assets/curso/images/tema1/fig_dofa.svg").m-auto
              .col-md-3
                a.boton-1.me-2.indicador__container(
                  :href="obtenerLink('downloads/MatrizFODA.pdf')"
                  target="_blank"
                  type="application/pdf"
                  @mouseover="mostrarIndicador = false"
                )
                  img.mx-0(src='@/assets/curso/images/tema1/btn_1.svg',  alt='', style="width:60px; display:block; margin:auto 0 ;")
                  .indicador--click(v-if="mostrarIndicador")
   
          

      .py-3.py-md-4.tabs-c__content-item-1.tab-c.mg-top-2(titulo="Matriz de  PCI")
        .row.justify-content-center.align-items-center.p-4 
          .col-12.col-md-6.mb-3.mb-md-0
            h4 Matriz de  PCI
            p.mb-3 El Perfil de Capacidades Internas (PCI) es un instrumento para realizar un diagnóstico de las organizaciones  que permite evaluar las fortalezas y las debilidades analizadas, donde se reflejan los factores internos que afectan o aportan a su normal funcionamiento.  Su implementación consiste en determinar las áreas estratégicas y los factores críticos de ellas a evaluar, con el fin de aplicar la matriz y realizar un análisis por área, para luego consolidarlo por organización (Pedraza, 2015). 
            p.mb-3 Es una herramienta para realizar diagnóstico estratégico en una empresa involucrando todos los factores que afectan su operación corporativa. El PCI evalúa cinco categorías, a saber: capacidad directiva, capacidad competitiva, capacidad financiera, capacidad tecnológica y capacidad del talento humano.
            p.mb-0 El perfil de fortalezas y debilidades se representa gráficamente mediante calificaciones de la fortaleza o debilidad con relación a su grado (A M B), para luego ser valorada con respecto a su impacto en la escala de alto (A), medio (M), bajo (B). 
          .col-12.col-md-4.mb-3.mb-md-0
            .row.justify-content-end.align-items-center
                .col-md-12
                  figure
                    img(src="@/assets/curso/images/tema1/fig_dofa_2.svg").m-auto
                .col-md-3
                  a.boton-1.me-2.indicador__container(
                    :href="obtenerLink('downloads/MatrizdePCI.pdf')"
                    target="_blank"
                    type="application/pdf"
                    @mouseover="mostrarIndicador = false"
                  )
                    img.mx-0(src='@/assets/curso/images/tema1/btn_1.svg',  alt='', style="width:60px; display:block; margin:auto 0 ;")
                    .indicador--click(v-if="mostrarIndicador")
      .py-3.py-md-4.tabs-c__content-item-1.tab-c.mg-top-2(titulo="Modelo de las cinco fuerzas")
        .row.justify-content-center.align-items-center.p-4 
          .col-12.col-md-6.mb-3.mb-md-0
            h4 Modelo de las cinco fuerzas
            p.mb-3 El modelo estratégico de las cinco fuerzas de Michael Porter, estudia si es productivo crear una organización en un determinado sector con base en el mercado, y se concentra en realizar un análisis de la competitividad como herramienta estratégica gerencial. 

            p.mb-3 A través de este modelo, Porter se plantea conocer el estado de la empresa en el sector y el atractivo de la misma, que se determina por las siguientes cinco fuerzas:

            p - Rivalidad entre los competidores existentes en el sector. 
            p - Amenaza de entrada de nuevos competidores en el sector.
            p - Amenaza de aparición de productos sustitutivos en el sector. 
            p - Poder de negociación de los clientes.                                                                        
            p - Poder de negociación de los proveedores. 
            
          .col-12.col-md-4.mb-3.mb-md-0
            .row.justify-content-end.align-items-center
                .col-md-12
                  figure
                    img(src="@/assets/curso/images/tema1/fig_6.svg").m-auto
                .col-md-3
                  a.boton-1.me-2.indicador__container(
                    :href="obtenerLink('downloads/ModelodelasCincoFuerzas.pdf')"
                    target="_blank"
                    type="application/pdf"
                    @mouseover="mostrarIndicador = false"
                  )
                    img.mx-0(src='@/assets/curso/images/tema1/btn_1.svg',  alt='', style="width:60px; display:block; margin:auto 0 ;")
                    .indicador--click(v-if="mostrarIndicador")
      .py-3.py-md-4.tabs-c__content-item-1.tab-c.mg-top-2(titulo="Matriz EFI")
        .row.justify-content-center.align-items-center.p-4 
          .col-12.col-md-6.mb-3.mb-md-0
            h4 Matriz EFI
            p.mb-3 La matriz de Evaluación de los Factores Internos (EFI) busca consolidar y analizar las fortalezas y debilidades más relevantes de la organización. Es una herramienta para formular estrategias y se implementa asignando un peso relativo a cada factor, de 0, equivalente a sin importancia, va ascendiendo hasta llegar a 10, que significa muy importante, de tal manera que la suma de todos los pesos asignados a los factores sea igual a 100%. 

            p.mb-3 Así mismo, es importante aclarar que se asigna una calificación entre 1 y 2 a cada una de las debilidades y entre 3 y 4 a las fortalezas, con el fin de indicar el factor que este representa, así:

            p 1: debilidad mayor 
            p 2: debilidad menor. 
            p 3: fortaleza menor.  
            p 4: fortaleza mayor.                                                                       
            
          .col-12.col-md-4.mb-3.mb-md-0
            .row.justify-content-end.align-items-center
                .col-md-12
                  figure
                    img(src="@/assets/curso/images/tema1/fig_dofa_3.svg").m-auto
                .col-md-3
                  a.boton-1.me-2.indicador__container(
                    :href="obtenerLink('downloads/MatrizEFI.pdf')"
                    target="_blank"
                    type="application/pdf"
                    @mouseover="mostrarIndicador = false"
                  )
                    img.mx-0(src='@/assets/curso/images/tema1/btn_1.svg',  alt='', style="width:60px; display:block; margin:auto 0 ;")
                    .indicador--click(v-if="mostrarIndicador")
      .py-3.py-md-4.tabs-c__content-item-1.tab-c.mg-top-2(titulo="Matriz MEFE")
        .row.justify-content-center.align-items-center.p-4 
          .col-12.col-md-6.mb-3.mb-md-0
            h4 Matriz MEFE
            p.mb-3 La Matriz de evaluación del factor externo (EFE) tiene como fin develar la posición estratégica que tiene la organización en el ámbito al que pertenece. En ella, se resumen y evalúan las oportunidades y amenazas de la empresa. Se implementa elaborando una lista de oportunidades y amenazas del medio, se evalúa la importancia relativa de cada una para el desempeño de la unidad empresarial, y se asigna un rango, teniendo en consideración que las oportunidades suelen tener pesos más elevados que las amenazas. Se asigna a criterio propio una calificación de 1 a 4 para cada uno de los factores concluyentes del éxito, con el fin de subrayar  si las estrategias actuales responden con pertinencia al factor crítico que corresponde y qué está haciendo la misma para enfrentarlo. Este es un ejemplo del rango y calificación que se debe asignar: 

            p 4: respuesta superior, es decir, la empresa está trabajando duro.  
            p 3: respuesta superior a la media, la microempresa está trabajando más que las demás dentro del mismo sector.
            p 2: respuesta media, la microempresa está trabajando lo justo.
            p 1: respuesta mala, la microempresa no está haciendo nada al respecto.                                                                      
            
          .col-12.col-md-4.mb-3.mb-md-0
            .row.justify-content-end.align-items-center
                .col-md-12
                  figure
                    img(src="@/assets/curso/images/tema1/fig_dofa_4.svg").m-auto
                .col-md-3
                  a.boton-1.me-2.indicador__container(
                    :href="obtenerLink('downloads/MatrizMEFE.pdf')"
                    target="_blank"
                    type="application/pdf"
                    @mouseover="mostrarIndicador = false"
                  )
                    img.mx-0(src='@/assets/curso/images/tema1/btn_1.svg',  alt='', style="width:60px; display:block; margin:auto 0 ;")
                    .indicador--click(v-if="mostrarIndicador")
      .py-3.py-md-4.tabs-c__content-item-1.tab-c.mg-top-2(titulo="Matriz POAM")
        .row.justify-content-center.align-items-center.p-4 
          .col-12.col-md-6.mb-3.mb-md-0
            h4 Matriz POAM
            p.mb-3 La Matriz POAM significa perfil de oportunidades y amenazas del medio. Es un método que ayuda a identificar y evaluar amenazas y oportunidades potenciales de una empresa. Cuando un grupo estratégico evalúa su impacto e importancia, se identifica si la amenaza causada por un aspecto en el entorno se configura en amenaza u oportunidad.

            p.mb-3 Para la elaboración de la POAM, se necesita:

            p - Obtención de la información primaria y secundaria.
            p - Identificación de las oportunidades y amenazas.
            p - El grupo estratégico selecciona las áreas de análisis. 
            p - Priorización y calificación de los factores externos.
            p - Calificación del impacto.
            p - Elaboración de POAM.      

            p.mb-0 Esta matriz facultará la realización del estudio del medio empresarial, el cual revelará la posición de la compañía frente al medio en el que se desempeña. (Pedraza, 2015).                                                              
          .col-12.col-md-4.mb-3.mb-md-0
            .row.justify-content-end.align-items-center
                .col-md-12
                  figure
                    img(src="@/assets/curso/images/tema1/fig_dofa_5.svg").m-auto
                .col-md-3
                  a.boton-1.me-2.indicador__container(
                    :href="obtenerLink('downloads/MatrizPOAM.pdf')"
                    target="_blank"
                    type="application/pdf"
                    @mouseover="mostrarIndicador = false"
                  )
                    img.mx-0(src='@/assets/curso/images/tema1/btn_1.svg',  alt='', style="width:60px; display:block; margin:auto 0 ;")
                    .indicador--click(v-if="mostrarIndicador")
                        
      
    p.mb-3 Se puede concluir que existen diferentes herramientas para evaluar el contexto interno y externo de una organización, siendo de gran importancia la suma de ellas, pues cada una con sus complementarios permite esclarecer el panorama de la organización, encontrando estrategias que aporten a potencializar fortalezas, así como a convertir debilidades en fortalezas, a redituar las oportunidades que brinda el entorno y especialmente a preparase para evitar los impactos de la ocurrencia de amenazas.


    .row.aling.my-5   
      .col-lg-10(data-aos="zoom-in-down")
        .cajon.color-custom-1.p-4.mb-4.p-4
          .row.justify-content-around.align-items-center
            .col-lg-12
              .row.justify-content-between.align-items-center
                .col.mb-3.mb-sm-0
                  p.mb-0 El direccionamiento estratégico ha sido de gran aporte al desarrollo científico de la administración y, por tanto, de las organizaciones. Este conglomerado es el resultado de ese avance estratégico, dando a las organizaciones la oportunidad de convertirse en líderes en el mercado al que pertenecen.













































































































    

  
</template>

<script>
export default {
  name: 'Tema1',
  components: {},
  data: () => ({
    modal1: false,
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
